// extracted by mini-css-extract-plugin
module.exports = {"loader":"ProgressLoader_loader__ZgcH_","rotationBack":"ProgressLoader_rotationBack__LN3vp"};